import React, {Component} from 'react';
import {connect} from 'react-redux';

import UserInfoList from './user-info';
import Box from 'components/box';

const mapStateToProps = state => ({
  user: state.auth.get('user')
});

class UserInfo extends Component {
  render() {
    return(
      <div>
        <Box title3="Інформація користувача">
          <UserInfoList user={this.props.user} />
        </Box>
      </div>
    )
  }
}

export default connect(mapStateToProps)(UserInfo);



// WEBPACK FOOTER //
// ./src/cabinet/user/index.js